module.exports = __webpack_public_path__ + "static/img/houqingyichang.35d445b0.png";